import { pathOr, filter, slice, join } from 'ramda';

import { notEmpty } from 'utils/ramdaAdditions';
import {
    TEXT,
    IMAGE,
    FRAME,
    SCRIPT,
    XMHT,
    XMLFORM,
    XMLTEST,
    XMLRESUME,
    XMLVCV,

    DOCTYPE_TESTING_SCORES,
    XMLRESUME_CODE,
    XMLVCV_CODE,
} from 'constants/documentTypes';

const previewFileTypes = {
    'jpe': IMAGE,
    'jfif': IMAGE,
    'jpeg': IMAGE,
    'jpg': IMAGE,
    'png': IMAGE,
    'txt': TEXT,
    'html': FRAME,
    'htm': FRAME,
    'script': SCRIPT,
    'xmht': XMHT
};

export const getDocumentPreviewType = document => {
    const documentType = previewFileTypes[document.fileType];
    if (documentType) {
        return documentType;
    }

    if (document.xmlType) {
        return XMLFORM;
    }

    if (document.docType === DOCTYPE_TESTING_SCORES) {
        return XMLTEST;
    }

    if (document.docType === XMLRESUME_CODE && document.fileType === 'xml') {
        return XMLRESUME;
    }

    if (document.docType === XMLVCV_CODE && document.fileType === 'xml') {
        return XMLVCV;
    }

    return null;
};

export const getValue = (fieldObj) => {
    return pathOr('', ['value'], fieldObj);
};

export const xmlArrayToObj = (xmlArray) => {
    const xmlObj = {};

    xmlArray.forEach(element => {
        xmlObj[element.id] = element;
    });

    return xmlObj;
};

export const checkGroup = (renderFunction) => (obj) => {
    return notEmpty(filter(Boolean, obj)) ? renderFunction(obj) : null;
};

export const getPhoneString = (contactPhoneCode, contactPhone) => {
    if (contactPhoneCode) {
        return `+7 (${slice(2, 5, contactPhoneCode)}) ${slice(0, 3, contactPhone)}-${slice(3, 5, contactPhone)}-${slice(5, 7, contactPhone)}`;
    } else {
        return contactPhone;
    }
};

export const getComputerSkills = (computerSkills) => {
    if (computerSkills) {
        const computerSkillsArray = computerSkills.map(computerSkillObject => {
            return computerSkillObject.NISSAN_COMPSKILLS_STR
        })

        return join(', ', computerSkillsArray);
    } else {
        return '';
    }
}
